import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Scissors } from 'lucide-react';
import { EmbroideryConverter } from '@/components/EmbroideryConverter';
import type { UploadedImage } from '@/pages/ImageToolsHub';

interface EmbroideryConversionToolProps {
  images: UploadedImage[];
}

export const EmbroideryConversionTool: React.FC<EmbroideryConversionToolProps> = ({ images }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Scissors className="w-5 h-5" />
          Embroidery Conversion
        </CardTitle>
        <CardDescription>
          Convert images to embroidery-ready formats (DST, PES, JEF)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <EmbroideryConverter />
      </CardContent>
    </Card>
  );
};
